
import { colors } from "@mui/material";
import "./allInOneHrms.css";
import { Helmet } from "react-helmet";

const AllInOneHrms = () => {
    const erpModules = [
        {
            iconClass: "bi-clock-history",
            backgroundColor: '#0085FF',
            title: "Time & Attendance",
            description:
                "Configure multiple shifts, overtime calculation rules, and other complex scenarios. Capture attendance with geo-tracking, geo-fencing, and selfie-uploads via the mobile app. Lock attendance entry to ensure integrity while allowing backdated entry through an approval process.",
        },
        {
            iconClass: "bi-receipt-cutoff",
            backgroundColor: '#DD4F24',
            title: "Payroll Software",
            description:
                "Configure multiple pay structures for different employee levels, different pay periods, and other custom policies. Simplify the work of the HR and Finance team with easy disbursement. TechCongnics HRMS integrates with popular banks such as ICICI and Axis Bank, wherein files can be generated and uploaded onto the bank portal.",
        },
        {
            iconClass: "bi-calendar-check",
            backgroundColor: '#FBB034',
            title: "Leave Management",
            description:
                "We will establish clear leave policies for different employee levels, including C-level and managers, along with specific leave types based on our needs. Default types such as maternity, sick leave, special days, work-from-home, and compensatory time off are included.",
        },
        {
            iconClass: "bi-credit-card",
            backgroundColor: '#FF6D01',
            title: "Advance Payments",
            description:
                "Advance payments are designed to automate and manage the entire process, including requests, approvals, disbursement, and recovery, ensuring transparency and compliance.Advance payment for salary periods during an employee's extended leave.",
        },
        {
            iconClass: "bi-receipt",
            backgroundColor: '#34A853',
            title: "Expense Management",
            description:
                "Create and track employee expenses quickly using customizable templates.",
        },

        {
            iconClass: "bi-person-badge",
            backgroundColor: '#0085FF',
            title: "Employee Self-Service",
            description:
                "An ESS portal offers employees anywhere, anytime access to their official information. This ensures better transparency, engagement, and higher productivity",
        }


    ];

    return (
        <>
            <Helmet>
                <title>
                    All-in-One HRMS Software for Payroll & Workforce Management | TechCognics
                </title>

                <meta
                    name="description"
                    content="An all-in-one HRMS software to manage payroll, attendance, leave, expenses, and the complete employee lifecycle from a single cloud-based platform."
                />

                <meta
                    name="keywords"
                    content="all in one HR software, HRMS platform, integrated HR system, payroll HR software, workforce management software, cloud HRMS, HR automation system"
                />

                <meta
                    property="og:title"
                    content="All-in-One HRMS Software for Payroll & Workforce Management"
                />

                <meta
                    property="og:description"
                    content="Simplify HR operations with an integrated HRMS platform covering payroll, attendance, leave, expenses, and employee management."
                />

                <meta property="og:type" content="website" />
            </Helmet>
            <section id="erp_implement" className="app-section">
                <div className="container-fluid" data-aos="fade-up">

                    {/* Heading */}
                    <div className="site-heading text-center mb-4">
                        <div className="text-center feature-heading" style={{ color: '#0F4F93' }}>All-in-one HR Software</div>

                        <p>
                            Everything you need to streamline HR operations in one centralized system.
                        </p>
                    </div>

                    {/* Cards */}
                    <div className="row g-4 justify-content-center" id="erp">
                        {erpModules.map((component, index) => (
                            <div
                                key={index}
                                className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center"
                                data-aos="zoom-in"
                            >
                                <div className="erp-module-card">
                                    <div className="row d-flex">
                                        <div className="erp-icon col-auto d-flex" style={{ backgroundColor: component.backgroundColor, color: component.colors, borderRadius: '50%', color: 'white' }}>
                                            <i className={`bi ${component.iconClass}`}></i>
                                        </div>
                                        <div className="col-auto justify-content-center align-self-center">
                                            <h5 className="erp-title">{component.title}</h5>
                                        </div>
                                    </div>
                                    <div className="ms-3">
                                        <p className="erp-descs p-0">
                                            {component.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

        </>

    );
};

export default AllInOneHrms;




